  <div class="org-list">
     <div class="p-1 company-list-title">Organisations</div>
      <app-organisation-list-item *ngFor="let org of this.organisations" [organisation]="org"></app-organisation-list-item>
  </div>
  <div class="text-center p-2">
      <a class="btn btn-outline-primary" [routerLink]="'/dashboard/configuration/organisation/add/'">Add Organisation</a>
  </div>


